var player;
var middleViewEl;
var blocktouchEl;
var defaultUrl = "rtmp://bintu-play.nanocosmos.de/play";
var defaultServer = {
    "websocket": "wss://bintu-play.nanocosmos.de:443/h5live/stream",
    "hls": "https://bintu-play.nanocosmos.de:443/h5live/http/playlist.m3u8",
    "progressive": "https://bintu-play.nanocosmos.de:443/h5live/http/stream.mp4"
};
var isPlaying = false;
var isMuteH = true;
var params = new URL(window.location.href).searchParams;
var enableSound = params.get("enableSound");
var soundoff = $('.soundoff');
var soundon = $('.soundon');

var streamNames = [
    "XpjSI-X3Chu"
];
$(window).on('load', function () {
    callApiToken();
});

function callApiToken() {
    $.ajax({
        url: 'https://api-csn-s.gameland.today/api/v1/stream/',
        type: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        data: JSON.stringify({
            'groupId': '360d8af8-5d64-43df-9bd9-fa91ad6f9c60',
            'stream name': 'XpjSI-X3Chu',
			'site': siteid
        }),
        dataType: 'json',
        success: function (data, status) {

            // ✅ Detect thiết bị
            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

            var config = {
                "source": {
                    "group": {
                        "id": "360d8af8-5d64-43df-9bd9-fa91ad6f9c60",
                        "security": {
                            "jwtoken": data.data.token
                        }
                    },
                    "entries": [
                        {
                            "index": 0,
                            "label": "high",
                            "tag": "this is a high quality stream",
                            "info": {
                                "bitrate": 1200,
                                "width": 1280,
                                "height": 720,
                                "framerate": 30
                            },
                            "h5live": {
                                "server": defaultServer,
                                "rtmp": {
                                    "url": defaultUrl,
                                    "streamname": streamNames[0]
                                }
                            }
                        },
                        {
                            "index": 1,
                            "label": "medium",
                            "tag": "this is a medium quality stream",
                            "info": {
                                "bitrate": 800,
                                "width": 864,
                                "height": 480,
                                "framerate": 30
                            },
                            "h5live": {
                                "server": defaultServer,
                                "rtmp": {
                                    "url": defaultUrl,
                                    "streamname": streamNames[0]
                                }
                            }
                        },
                        {
                            "index": 2,
                            "label": "low",
                            "tag": "this is a low quality stream",
                            "info": {
                                "bitrate": 400,
                                "width": 426,
                                "height": 240,
                                "framerate": 15
                            },
                            "h5live": {
                                "server": defaultServer,
                                "rtmp": {
                                    "url": defaultUrl,
                                    "streamname": streamNames[0]
                                }
                            }
                        }
                    ],
                    "options": {
                        "adaption": {
                            "rule": "none"
                        },
                        "switch": {
                            'method': 'server',
                            'pauseOnError': false,
                            'forcePlay': true,
                            'fastStart': false,
                            'timeout': 10,
                        }
                    },
                    "startIndex": 1
                },
                "playback": {
                    "autoplay": !isMobile, // ✅ chỉ autoplay trên desktop
                    "automute": true,
                    "muted": true,
                    "faststart": true
                },
                "style": {
                    "displayMutedAutoplay": false,
                    "controls": false,
                    "fullScreenControl": false,
                    "interactive": true
                },
                "events": {
                    "onSwitchStreamSuccess": function (e) {
                    },
                    "onReady": function (e) {
                        middleViewEl = document.getElementById('middleView-playerDiv');
                        middleViewEl.ontouchmove = function (event) {
                            event.preventDefault();
                        }
                        blocktouchEl = document.getElementById('blocktouch-playerDiv');
                        blocktouchEl.ontouchmove = function (event) {
                            event.preventDefault();
                        }
                    },
                    "onPlay": function (e) {
                        middleViewEl.style.display = "none";
                        blocktouchEl.style.display = "none";
                        if (isMuteH) {
                            setSoundOffEl();
                            if (enableSound == null || enableSound == undefined || enableSound == "true") {
                                var soundoff = jQuery('.soundoff');
                                var soundon = jQuery('.soundon');
                                soundoff.hide();
                                soundon.show();
                                soundoff.click();
                            }
                        } else {
                            setSoundOnEl();
                        }

                        isPlaying = true;
                    },
                    "onPause": function (e) {
                    },
                    "onLoading": function (e) {
                    },
                    "onStartBuffering": function (e) {
                    },
                    "onStopBuffering": function (e) {
                    },
                    "onMute": function (e) {
                        if (isPlaying) {
                            setSoundOffEl();
                        }

                        isMuteH = true;
                    },
                    "onUnmute": function (e) {
                        if (isPlaying) {
                            setSoundOnEl();
                        }

                        isMuteH = false;
                    },
                    "onPause": function (e) {
                        hideSoundEl();
                        if (e.data != null && e.data != undefined && e.data.reason != null && e.data.reason != undefined && e.data.reason !== "playbacksuspended") {
//                                 console.log(e);
                        } else {
                            window.location.reload();
                        }
                        isPlaying = false;
                    }
                }
            };
            player = new NanoPlayer("playerDiv");
            player.setup(config).then(function (config) {
            }, function (error) {
                alert(error.message);
            });
        },
        error: function (data, status, e) {
            console.log(status);
        }
    });
}
